/**
 * Organization Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Token } from './token';


export interface DirectorySetting { 
    token?: Token;
    isImportGroup?: boolean;
    isExportGroup?: boolean;
    isImportUser?: boolean;
    isExportUser?: boolean;
    isImportCustomAttribute?: boolean;
    isExportCustomAttribute?: boolean;
    tenantId?: string | null;
    domain?: string | null;
    userDeltaLink?: string | null;
    groupDeltaLink?: string | null;
    membersDeltaLink?: string | null;
    isTokenValid?: boolean;
    outboundGroups?: Array<string> | null;
    inboundGroup?: string | null;
    isResync?: boolean;
    server?: string | null;
    defaultOu?: string | null;
    exportPasswords?: boolean;
    importPasswords?: boolean;
}

